import React, { useEffect, useState} from "react";
import Modal from 'react-modal';

import styled from 'styled-components';
import { useTranslation } from "react-i18next";

import { eventTracker } from "../../services/eventTracker";
import SeedPhraseWarningComponent from './SeedPhraseWarningComponent';
import ShowStealComponent from './ShowStealComponent';

import link from '../../styles/assets/copy_link.svg';
import link_white from '../../styles/assets/copy_link_white.svg';
import back from '../../styles/assets/back_arrow.svg';
import warning from '../../styles/assets/warning_icon.svg';

import {copyText} from '../../utils/copyText';

const SeedPhraseTitle = styled.div`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #FFFFFF;
`;

const Warning = styled.div`
    background: rgba(255, 96, 96, 0.08);
    border-radius: 12px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    color: #FFFFFF;
    padding: 17px 50px;
    margin-top: 26px;
    padding-left: 18px;
    margin-bottom: 90px;
    display: flex;
`;

const BlueButton = styled.div`
    background: linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%);
    border-radius: 8px;
    display: flex;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #FFFFFF;
    padding: 12px;
    justify-content: center;
    align-content: center;
    margin-top: auto;
    margin-left: 16px;
    margin-right: 16px;
`;

/* Styling the SeedWord component */
const SeedWord = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 32px;
    /* or 178% */

    display: flex;
    align-items: center;
    justify-content: flex-start;
    letter-spacing: -0.02em;
    color: #fff;
    margin-left: 50px;
`;


const customStyles = {
    overlay:{
        zIndex: 1,
    },
    content: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "black",
        zIndex: -1,
    },
};

Modal.setAppElement('#root');


const getMnemonic: any = () => {
    let walletInfo = localStorage.getItem('gw-wallet-info')
    let seed = ''
    if (walletInfo) {
        seed = JSON.parse(walletInfo).mnemonic
    }
    return seed;
}


const SeedPhraseComponent = (props: any) => {
    const [seed, setSeed] = useState('');
    const  {t} = useTranslation();
    const [showWarning, setShowWarning] = useState(false);
    
    useEffect(() => setSeed(getMnemonic()), []);

    const seedPhrase = seed.split(' ').map((item: any, index: any) => {
        return (                       
            <SeedWord key={`seed-list-${index}`}>
              <span style={{color: '#7A7F9E', marginRight: 12}}>{index + 1}</span> {item}
            </SeedWord>
        );
    });
    
    
    const [showSteal, setShowSteal] = useState(false);

    const copySeedPhrase = () =>{
        copyText(seed, t('Seed phrase copied'));
        eventTracker('seed_phrase_copied', {});
        setShowWarning(false);
    }
    
    return (
        <>
          <Modal isOpen={props.showSeed} style={customStyles}>
            {!showSteal && (
                <div style={{display:'flex',
                             flexDirection:'column',
                             position: 'relative',
                             height: '100%',
                             
                }}>
                  <div style={{display:'flex', position: 'relative',justifyContent:'center', alignItems:'center'}}>
                    <img
                        style={{position: 'absolute', top:'50%', transform: 'translateY(-50%)', left:20}}
                        src={back} alt='back arrow' onClick={() => {
                            props.setShowSeed(false);
                            eventTracker('close_seed_phrase_click', {})
                        }} className='hover'/>
                    <SeedPhraseTitle>
                      <span>{t('Seed phrase')}</span>
                    </SeedPhraseTitle>
                  </div> 
                  <Warning>
                    <img src={warning} alt='warning' style={{marginRight: 12}}/>
                    <span>{t('Never share your seed phrase with other people')}</span>
                  </Warning>
                  <div style={{
                      display: 'flex',
                      height: 200,
                      flexDirection: 'column',
                      flexWrap: 'wrap',
                      justifyContent: 'center',
                      alignContent: 'center',
                  }}>
                    {seedPhrase}
                  </div>
                  <BlueButton onClick={() => {
                      //setOpen(false);
                      setShowWarning(true);
                      //copyText(seed, t('Seed phrase copied'));
                      eventTracker('seed_phrase_copy_click', {})
                  }}>
                    <img src={link_white} alt='copy' style={{marginRight: 16}}/>
                    {t('Copy Seed Phrase')}
                  </BlueButton>
                </div>
            )}
            {(showSteal) && (
                <ShowStealComponent
                    setOpen={props.setShowSeed}
                />
            )}
          </Modal>
          <SeedPhraseWarningComponent
              showWarning={showWarning}
              setShowWarning={setShowWarning}
              copySeedPhrase={copySeedPhrase}
              setShowLoser={()=>{setShowSteal(true);}}
              setShowSeed={props.setShowSeed}
          />
        </>
    );
}

export default SeedPhraseComponent;
